import { useEffect, useState } from 'react';

// UI components & helpers
import Brand from '../components/splash/Brand';
import HelpFooter from '../components/HelpFooter';
import { to_euro } from '../utils/utils';

// hooks
import useFeed from '../hooks/useFeed';
import useProducts from '../hooks/useProducts';
import useSettings from '../hooks/useSettings';
import Ingot from '../components/Ingot';



export default function Products () {

  // hook data deconstruction.
  const { feed, error:fError } = useFeed();
  const { products, error:pError, loading:pLoad } = useProducts();
  const { settings, error:sError, loading:sLoad } = useSettings();

  // local states.
  const [ masterKind, setKind ] = useState( 'INGOT' );
  const [ error, set_error ] = useState( null );

  useEffect(() => {
    // handle feed errors.
    if ( fError.type || pError.type || sError.type ) {
      console.log( 'feed error', fError );
      console.log( 'products error', pError );
      console.log( 'settings error', sError );
      set_error( 'feed error', fError, pError, sError );
    }

    // use feed data.
    /* console.log( 'feed', feed );
    if ( Object.keys(products).length !== 0 ) {
      console.log( 'products', products );
    }

    if ( Object.keys(settings).length !== 0 ) {
      console.log( 'settings', settings );
    }
    */
  }, [ feed, fError, pError, sError ] );



  return (
    <div className='full with-help-footer'>
      <Brand
        variant = "lg"
        align = "left"
        showChevron = 'true' />

      { !error &&
        <div className='cbody--'>

          {/* DIRECT FEEDS */}
          <div className='button-row'>

            <div className=' price gold '>
              Oro fix: <span className='silver'>{to_euro( feed.XAU )}</span> </div>

            <div className=' price gold '>
              Argento fix: <span className='silver'>{to_euro( feed.XAG )}</span> </div>

            <div className=' price gold '>
              aggiornato: <span className='silver'>{feed.LAST_UPDATE}</span> </div>

          </div>

          {/* KIND SWITCH */}
          <div className='button-group'>

            <button
              className = ' button gold-bg'
              onClick   = { () => setKind( 'INGOT' ) } >
              Lingotti </button>

            <button
              className = ' button gold-bg'
              onClick   = { () => setKind( 'PAC' ) } >
              Pac </button>

          </div>

          {/* THE PRODUCTS */}
          <div className='tabs-- '>

            { masterKind === 'INGOT' && ingot_tabs('XAU') }
            { masterKind === 'INGOT' && ingot_tabs('XAG') }

            { masterKind === 'PAC' && ingot_tabs('XAUPAC') }
            { masterKind === 'PAC' && ingot_tabs('XAGPAC') }

          </div>
        </div>
      }

      { error && <p>{ error }</p> }

        <HelpFooter
          href="mailto:support@gekogold.com"
          target="_self" />
    </div>
  )


  // FUNCTIONS 2026 :: WIP :::::

  function ingot_tabs( kind )
  {
    let tabs = [];
    products.forEach(( p, i ) => {
      if ( p.kind === kind ) {
        tabs.push(
          < Ingot
            key   = { p.kind + i }
            data  = { p }
            feed  = { feed }
            masterKind = { masterKind }
            confine = { false }
          />
        );
      }
    });
    return tabs;
  }

}
